import { mutateGraphQL } from '~/hooks/graphql.js';

const registerCustomer = `
  mutation RegisterCustomer(
    $firstName: String,
    $lastName: String,
    $email: String!,
    $password: String!,
    $captchaToken: String!
  ) {
		registerCustomer(input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      password: $password,
      captchaToken: $captchaToken
    }) {
			viewer {
        id
        email
      }
		}
	}
`;

/**
 * mutateGraphQL returns a callback method.
 *
 * { 'email', 'password', 'captchaToken' }
 */
export const getRegistrationMutationHandler = () => {
  const { mutationHandler } = mutateGraphQL(registerCustomer);

  return { mutationHandler };
}
